import classnames from 'classnames';

import styles from './ChevronButton.module.scss';

export type Direction = 'LEFT' | 'RIGHT';

export const ChevronButton = ({
  direction = 'LEFT',
  disabled = false,
  onClick,
}: {
  direction?: Direction;
  disabled?: boolean;
  onClick?: () => void;
}) => (
  <button
    className="ds-interactive-component px8"
    onClick={onClick}
    type="button"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classnames(styles.chevron, {
        [styles.right]: direction === 'RIGHT',
        [styles.disabled]: disabled,
      })}
    >
      <path
        d="M9.99935 12.6667L4.66602 8L9.99935 3.33333"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);
